import { render } from "./header-app.vue?vue&type=template&id=2bf5f426&scoped=true"
import script from "./header-app.vue?vue&type=script&lang=js"
export * from "./header-app.vue?vue&type=script&lang=js"

import "./header-app.vue?vue&type=style&index=0&id=2bf5f426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf5f426"]])

export default __exports__